// extracted by mini-css-extract-plugin
export default {"modal":"UL-z","modalOverlay":"VL-z","outfitHeading":"WL-z"};